export default __webpack_public_path__ + "static/media/rewards-icon.cf1eea5c.svg";